import { Box } from '@mui/material';
import { PrimaryInput } from './PrimaryInput';
import { useContext, useEffect, useState } from 'react';
import { DataContext } from '../contexts/DataContext';

export const InputCode = (props) => {
  const { onChange, initialCode } = props;
  const { data } = useContext(DataContext);
  const [code, setCode] = useState(
    initialCode?.length > 0
      ? [
          initialCode?.substring(0, 3) || '',
          initialCode?.substring(3, 6) || '',
          initialCode?.substring(6, 9) || '',
          initialCode?.substring(9, 12) || '',
        ]
      : ['', '', '', '']
  ); // Each index holds 3 characters now

  const handleChange = (index, value) => {
    if (!/^(?:\D*\d{0,3}\D*)*$/.test(value)) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
    onChange(newCode.join(''));

    if (value.length === 3 && index < 3) {
      document.getElementById(`sms-code-${index + 1}`)?.focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === 'Backspace') {
      if (code[index].length === 0 && index > 0) {
        // Move to the previous input only when the current one is empty
        document.getElementById(`sms-code-${index - 1}`)?.focus();
      } else {
        // Prevent the default backspace behavior and update state correctly
        event.preventDefault();
        const newCode = [...code];
        newCode[index] = newCode[index].slice(0, -1);
        setCode(newCode);
        onChange(newCode.join(''));
      }
    }
  };
  useEffect(() => {
    if (data?.file?.name && !data?.submitted) setCode(['', '', '', '']);
  }, [data]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {[0, 1, 2, 3].map((index) => (
        <PrimaryInput
          id={`sms-code-${index}`}
          autoComplete="off"
          inputProps={{
            autoComplete: 'new-password',
            maxLength: 3,
            sx: { paddingInline: 0 },
          }}
          value={code[index]}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          placeholder="XXX"
          sx={{
            flex: 1,
            textAlign: 'center',
            paddingInline: '0',
            '& .MuiInputBase-root': {
              width: '100%',
              height: '100%',
              padding: '0px',
              background: '#F6F4F0',
              border: '1px solid #E5E5E5',
            },
            '& .MuiInputBase-input::placeholder': {
              color: '#808185',
              opacity: 1,
              fontSize: '16px',
              lineHeight: '21px',
              fontWeight: '700',
            },
          }}
        />
      ))}
    </Box>
  );
};
